<ion-header class="main-header">
  <ion-toolbar color="tertiary" class="mobile-visibility">
    <div class="title-block title-block-custom">
      <div class="icon-title">
        <ion-icon name="arrow-back-outline" class="back-button" (click)="goBack()"></ion-icon>
        <ion-title class="title">Research Report</ion-title>
      </div>
    </div>
  </ion-toolbar>
</ion-header>
<ion-content>
    <div class="container panel-wrapper">
         <div class="header desktop-visibility">
            <img (click)="goBack()" src="../../../assets/svg/back-icon.svg" alt="img">
            <p>Research Report</p>
          </div>
          <div class="panel-content mt-0">
            <div class="market-mantra-page">
                 <img src="../../../assets/svg/MMicon.jpg" alt="img">
              <div>
              <h1>Market Mantra</h1>
              <p >Get your Daily Indian Stock Market Research Report for actionable insights every morning.</p>
              <button type="button" class="view-link" (click)="openPdf()">View Report</button></div>
            </div>

            <!-- Tabs Section -->
            <div class="tabs-container">
              <div class="tabs-header">
                <button
                  *ngFor="let tab of tabItems"
                  [class.active]="selectedTab === tab.id"
                  class="tab-button"
                  (click)="selectTab(tab.id)"
                >
                  {{ tab.label }}
                </button>
              </div>

              <div *ngIf="selectedTab === 'mtf'" class="Dashboard-data-mtf">
<div class="tabs-content">

  <!-- Loading -->
  <div *ngIf="loadingTab" class="loading-message">
    Loading data...
  </div>

  <ng-container *ngIf="!loadingTab">

    <!-- Dashboard -->
    <div *ngIf="mtfDashboard" class="dashboard">

      <div class="dashboard-card">
        <div class="dashboard-title">Total Calls</div>
        <div class="dashboard-value">
          {{ mtfDashboard?.totalCalls }}
        </div>
      </div>

      <div class="dashboard-card">
        <div class="dashboard-title">Positive Calls</div>
        <div class="dashboard-value">
          {{ mtfDashboard?.positiveCalls }}
        </div>
      </div>

      <div class="dashboard-card">
        <div class="dashboard-title">Open Calls</div>
        <div class="dashboard-value">
          {{ mtfDashboard?.openCalls }}
        </div>
      </div>

      <div class="dashboard-card">
        <div class="dashboard-title">Closed Calls</div>
        <div class="dashboard-value">
          {{ mtfDashboard?.closedCalls }}
        </div>
      </div>

    </div>

    <!-- Stock Table -->
     <div class="table-main">
    <table
      *ngIf="mtfStockList?.length > 0"
      class="data-table"
    >
      <thead>
        <tr>
          <th>Date</th>
          <th>Stock Name</th>
          <th>Target</th>
          <th>Status</th>
          <th>Document</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let item of mtfStockList">

          <td>{{ formatDateForDisplay(item.Date) }}</td>

          <td>{{ item.Name }}</td>

          <td>{{ item.target }}</td>

          <td>{{ item.status }}</td>

          <td>
                        <button class="action-link" (click)="openActionPdf(item.Action)">
                          View
                        </button>
                      </td>

        </tr>
      </tbody>
    </table>
</div>
    <!-- No Data -->
    <div
      *ngIf="!mtfStockList || mtfStockList.length === 0"
      class="no-data-message"
    >
      No data available
    </div>

  </ng-container>

</div>
</div>

              <div *ngIf="selectedTab !== 'mtf'" class="tabs-content">
                <div *ngIf="loadingTab" class="loading-message">Loading data...</div>
                <table *ngIf="!loadingTab && currentTabData.length > 0" class="data-table">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Name</th>
                      <th>Document</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of currentTabData">
                      <td>{{ formatDateForDisplay(item.Date) }}</td>
                      <td>{{ item.Name }}</td>
                      <td>
                        <button class="action-link" (click)="openActionPdf(item.Action)">
                          View
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div *ngIf="!loadingTab && currentTabData.length === 0" class="no-data-message">
                  No data available
                </div>
              </div>
            </div>

              
            <div
                class="pdf-popup"
                *ngIf="showPdfPopup"
                tabindex="0"
                (click)="closePdf()"
                (contextmenu)="blockAction($event)"
                (copy)="blockAction($event)"
                (cut)="blockAction($event)"
                (selectstart)="blockAction($event)"
                (dragstart)="blockAction($event)"
              >
                <div class="pdf-container" (click)="$event.stopPropagation()" (contextmenu)="blockAction($event)">
                  <div class="relative">
                      <div class="close" (click)="closePdf($event)">x</div>
                   </div>
                  <div class="pdf-loader-overlay" *ngIf="pdfLoading">
                    <div class="pdf-spinner"></div>
                  </div>
                  <ngx-extended-pdf-viewer
                      [src]="pdfUrl"
                      [height]="'100%'"
                      [useBrowserLocale]="true"
                      [ignoreKeyboard]="true"


                      [showOpenFileButton]="false"
                      [showPrintButton]="false"
                      [showDownloadButton]="false"
                      [showPresentationModeButton]="false"
                      [showBookmarkButton]="false"
                      [showSecondaryToolbarButton]="false"
                      [showSidebarButton]="false"
                      [showFindButton]="false"
                      [enableEditor]="false"
                      [enableAnnotationEditor]="false"
                      [enableFormEditor]="false"

                      [textLayer]="true"

                      [showZoomButtons]="true"
                      [showZoomDropdown]="false"

                      (contextmenu)="blockAction($event)"
                      (pdfLoaded)="onPdfLoaded()"
                      (pdfLoadingFailed)="onPdfLoadError()"
                      >
                 </ngx-extended-pdf-viewer>
                </div>
              </div>

           </div>
    </div>
</ion-content>
